import {Price} from './price';

export class PriceDetail {
  price: Price;
  promoPrice: Price;
  promoDuration: number;
  promoLabel: string;

  constructor(price: number, promoPrice: number, promoDuration: number, promoLabel: string) {
    this.price = new Price(price);
    this.promoPrice = new Price(promoPrice);
    this.promoDuration = promoDuration;
    this.promoLabel = promoLabel;
  }

  public hasPromo(): boolean {
    return this.promoDuration > 0;
  }

  public hasPromoLessThanAMonth(): boolean {
    return this.promoDuration === 0;
  }
}
